var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-8 text-center home-text-2 slots__not-available"},[_c('p',{staticClass:"mb-4"},[_c('img',{attrs:{"src":"/img/icons/not-available.svg","alt":"No slots available"}})]),_c('p',{staticClass:"mb-0"},[_vm._v("No slots available")])])
}]

export { render, staticRenderFns }